<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <cal-picker v-model="reportForm.asAtDate" :label="labels.asAtDate" v-validate="'required'" :data-vv-as="labels.asAtDate" data-vv-name="asAtDate" :error-messages="errors.collect('asAtDate')"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs5>
                  <v-text-field v-model="reportForm.polNoFrom" :label="labels.polNoFrom" :error-messages="errors.collect('polNoFrom')" data-vv-name="polNoFrom" :data-vv-as="labels.polNoFrom" append-icon="mdi-magnify" @click:append="getHelpList('polNoFrom')" readonly></v-text-field>
                </v-flex>
                <v-spacer class="mt-2"></v-spacer>
                <v-flex xs5>
                  <v-text-field v-model="reportForm.polNoTo" :label="labels.polNoTo" :error-messages="errors.collect('polNoTo')" data-vv-name="polNoTo" :data-vv-as="labels.polNoTo" append-icon="mdi-magnify" @click:append="getHelpList('polNoTo')" v-validate="polNoToValidate" readonly></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" append-icon="mdi-magnify" @click:append="getHelpList('polType')" readonly></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-checkbox v-model="reportForm.printPolDet" :label="labels.printPolDet" data-vv-name="printPolDet" :data-vv-as="labels.printPolDet"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-checkbox v-model="reportForm.print000" :label="labels.print000" data-vv-name="print000" :data-vv-as="labels.print000"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12>
            <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
          </v-flex>
          <v-flex lg6 xs12>
            <v-btn  class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="polNoHelpList" width="900px" persistent>
        <PolicyHelpList3 v-if="polNoHelpList" :asAtDate="reportForm.asAtDate" @close="doClose" @doAssign="doAssignPolNo($event)"></PolicyHelpList3>
      </v-dialog>
      <v-dialog v-model="polTypeHelpList" width="900px" persistent>
        <MultiPolTypeHelpList @close="doClose" @doAssign="doAssignPolType($event)"></MultiPolTypeHelpList>
      </v-dialog>
      <v-dialog v-model="branchHelpList" width="900px" persistent>
        <MultiBranchHelpList @close="doClose" @doAssign="doAssignBranch($event)"></MultiBranchHelpList>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList2'
import PolicyHelpList3 from '@/components/core/common/dialog/PolicyHelpList3'

export default {
  data() {
    return {
      labels: {
        asAtDate: 'Report As At*',
        polNoFrom: 'Policy No. From',
        polNoTo: 'Policy No. To',
        polType: 'Policy Type',
        branch: 'Branches',
        printPolDet: 'Print Policy Details',
        print000: 'Print values in 000"s',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        asAtDate: new Date(),
        polNoFrom: '',
        polNoTo: '',
        polType: 'All',
        branch: 'All',
        printPolDet: true,
        print000: false,
        format: undefined,
        printRptRunTime: true
      },
      menu: {},
      supportedFormat: [],
      filterList: false,
      brnFilter: false,
      insdFilter: false,
      submitting: false,
      polTypeHelpList: false,
      branchHelpList: false,
      polNoHelpList: false,
      polNoType: undefined,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    polNoToValidate() {
      if (this.reportForm.polNoFrom !== '' && this.reportForm.polNoTo === '') {
        return 'required'
      } else {
        return ''
      }
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initRiskProf
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    toDateValidation(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    getHelpList(fieldName) {
      if (fieldName === 'polType') {
        this.polNoType = undefined
        this.polTypeHelpList = true
      } else if (fieldName === 'branch') {
        this.polNoType = undefined
        this.branchHelpList = true
      } else {
        this.polNoType = fieldName
        this.polNoHelpList = true
      }
    },
    doClose() {
      this.polNoHelpList = false
    },
    doAssignPolType(Obj) {
      this.reportForm.polType = Obj.finalSelectedItems.toString()
      this.polTypeHelpList = false
    },
    doAssignBranch(Obj) {
      this.reportForm.branch = Obj.finalSelectedItems.toString()
      this.branchHelpList = false
    },
    doAssignPolNo(Obj) {
      if (this.polNoType === 'polNoFrom') {
        this.reportForm.polNoFrom = Obj.polNo
      } else if (this.polNoType === 'polNoTo') {
        this.reportForm.polNoTo = Obj.polNo
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiPolTypeHelpList,
    MultiBranchHelpList,
    PolicyHelpList3
  }
}
</script>
